export const telefoonRegex = new RegExp(/^((\+|00(\s|\s?\\s?)?)31(\s|\s?\\s?)?(\(0\)[\\s]?)?|0)[1-9]((\s|\s?\\s?)?[0-9])((\s|\s?-\s?)?[0-9])((\s|\s?-\s?)?[0-9])\s?[0-9]\s?[0-9]\s?[0-9]\s?[0-9]\s?[0-9]$/);
export const emailRegex = new RegExp(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);

const exportedFunctions = {
  telefoonRegex,
  emailRegex,
};

export default exportedFunctions;
